import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OtpPopupComponent } from 'src/app/components/otp-popup/otp-popup.component';
import { ApiService } from 'src/app/services/api/api.service';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { createIDsValidatorEstate } from 'src/app/services/validators/custom.validators';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { checkTime } from 'src/app/util/Helper';
import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { NotificationService } from 'src/app/services/notification.service';
import { ConsentItem, ConsentService } from 'src/app/services/consent/consent.service';
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step1-testator',
  templateUrl: './step1-testator.component.html',
  styleUrls: ['./step1-testator.component.scss']
})
export class Step1TestatorComponent implements OnInit, AfterViewInit, OnDestroy {
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  formTitle: string = 'Testator Information';
  formSubtitle: string = 'A Testator is the person who makes a will, outlining how their assets should be distributed after their death.';

  contactInfoTitle: string = 'Testator Contact Information';
  detailsTitle: string = 'Testator Details';
  uploadDocsTitle: string = 'Upload Documents / Photo';

  phoneLabel : string = 'Mobile Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';

  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';

  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  kraPinLabel: string = 'KRA PIN';
  kraPinHint: string = 'Enter KRA PIN';
  addressLabel: string = 'Physical Address';
  addressHint: string = 'Enter Physical address';
  postalLabel: string = 'Postal Address';
  postalHint: string = 'Enter Postal Address';

  idFileLabel: string = 'Upload copy of ID (front + back) / Passport';
  kraFileLabel: string = 'Upload copy of KRA PIN';

  addTestatorText: string = '+  Add Testator';
  removeTestatorText: string = 'Remove Testator';

  requiredFieldString: string = 'Required field';

  loadingText: string = 'Requesting OTP';
  loadingRemove: boolean = false;
  currentIndex: number = 0;
  removeButtonText: string = 'Remove Testator';
  consentProvided: boolean = false;

  formErrors: { [key: string]: string } = {
    Phone: '',
    SecondaryPhone: '',
    Email: '',
    
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    IDNo: '',
    KraPin: '',
    Address: '',
    PostalAddress: '',

    IDNoImage: '',
    KraPinImage: '',
  };

  validationMessages: { [key: string]: {} } = {
    Phone: { required: this.requiredFieldString, pattern:'Invalid phone number', exist: 'This number is tied to an existing testator' },
    SecondaryPhone: { pattern:'Invalid phone number', exist: 'This number is tied to an existing testator' },
    Email: { required: this.requiredFieldString, email: "Invalid email address", exist: 'This email is tied to an existing testator' },

    Title: { required: this.requiredFieldString },
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    IDNo:  { required: this.requiredFieldString, min:'Invalid ID or Passport number', exist: 'This ID is tied to an existing testator' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing testator' },

    Address: { required: this.requiredFieldString },
    PostalAddress: { required: this.requiredFieldString },

    IDNoImage: { required: this.requiredFieldString },
    KraPinImage: { required: this.requiredFieldString },
  };

  testatorForm = this._formBuilder.group({
    testators: this._formBuilder.array([
      this.createTestatorsFormGroup()
    ]),
  });


  testatorPanels: ExpansionPanel[][] = [];
  private formChangesSubscription: Subscription[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private tabControlService: TabControlService,
    public estateControlService: EstateControlService,
    private validationService: ValidationService,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private consentService: ConsentService
  ) {
    this.populateData();
  }

  async ngOnInit(): Promise<void> {
    await this.populateForm();

    // Initialize all testatorPanels with their FormGroup already created
    this.getTestators().controls.forEach((_, i) => {
      if (!this.testatorPanels[i]) {
        this.testatorPanels[i] = this.generatePanelsForTestator(i);
      }
    });

    this.testatorForm.valueChanges.subscribe(()=> {
      this.logErrors();
    })
    this.setupFormChangeListeners();
  }

  ngAfterViewInit() {
    this.testators.forEach((_: any, i: number) => {
      this.testatorPanels[i] = this.generatePanelsForTestator(i);
    });
  }

  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.testatorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  get region(): any {
    return this.estateControlService.regionType;
  }
  get loading(): boolean {
    return this.notificationService.loading;
  }
  get testators(): any {
    return this.estateControlService.testators;
  }
  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }

  updateIDObject(index: number, object: any): void {
    if (!object) return;
    const currents = this.testators;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      ...{IDNoImage: object}
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecordWill(1, currents);
  }
  updateKraObject(index: number, object: any): void {
    if (!object) return;
    const currents = this.testators;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      ...{KraPinImage: object}
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecordWill(1, currents);
  }

  async populateData(): Promise<void> {
    if (this.TitleOptions.length === 0) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }
  }

  async populateForm(): Promise<void> {
    if (this.testators && this.testators.length > 0) {
      let testate = this.testators;

      testate.forEach(async (testator: any, index: number) => {
        if (index > 0 && !testator.verified) {
          testate.splice(index, 1);
          await this.estateControlService.updateRecordWill(1, testate);
        }
      });

      if (this.testators[0] && this.testators[0].verified && this.testators[0].verified == true) {
        this.consentProvided = true;
        const testatorsArray = this.testatorForm.get('testators') as FormArray;

        // Clear existing testators
        while (testatorsArray.length !== 0) {
          testatorsArray.removeAt(0);
        }
        
        // Add testators from storage
        this.testators.forEach((testator: any) => {
          if (testator.verified) testatorsArray.push(this.createTestatorsFormGroup(testator));
        });

      }
    }
  }

  createTestatorsFormGroup(testator: any = null): FormGroup {
    let form: FormGroup;

    // console.log('scajhbusdycbudsb ', testator);

    if (testator) {
      form = this._formBuilder.group({
        Title: [`${testator.Title || ''}`],
        FirstName: [`${testator.FirstName || ''}`, Validators.required],
        MiddleName: [`${testator.MiddleName || ''}`,],
        LastName: [`${testator.LastName || ''}`, Validators.required],
        Phone: [`${testator.Phone || ''}`, Validators.required],
        SecondaryPhone: [`${testator.SecondaryPhone || ''}`],
        Email: [`${testator.Email || ''}`, [Validators.required, Validators.email]],
        IDNo: [`${testator.IDNo || ''}`, [Validators.required, Validators.min(4), createIDsValidatorEstate('ID', this.getTestators(), this.testators)
        ]],

        KraPin: [`${testator.KraPin || ''}`],
        Address: [`${testator.Address || ''}`],
        PostalAddress: [`${testator.PostalAddress || ''}`],

        IDNoImage: [''],
        KraPinImage: ['']
      });

      if (testator.IDNoImage) {
        form.get('IDNoImage')?.setValue(testator.IDNoImage.stringValue);
      }

      if (testator.KraPinImage) {
        form.get('KraPinImage')?.setValue(testator.KraPinImage.stringValue);
      }

      if (testator.verified) {
        form.get('Address')?.addValidators([Validators.required]);
        form.get('PostalAddress')?.addValidators([Validators.required]);

        if (this.testatorForm && this.getTestators().length > 0 && testator.done == false) {
          this.validationService.addOrRemove3Validators(
            true,
            form.get('Email')!,
            [Validators.required,
              Validators.email,
              createIDsValidatorEstate('EMAIL', this.getTestators(), this.testators)
            ]
          );
          this.validationService.addOrRemoveSpecificValidators(
            true,
            form.get('Phone')!,
            [Validators.required,
              createIDsValidatorEstate('TEL', this.getTestators(), this.testators)
            ]
          );
          this.validationService.addOrRemoveOneValidator(
            true,
            form.get('SecondaryPhone')!,
            [createIDsValidatorEstate('TEL', this.getTestators(), this.testators)]
          );
          this.validationService.addOrRemove3Validators(
            true,
            form.get('KraPin')!,
            [Validators.required,
              Validators.pattern(/^[AP]\d{9}[A-Z]$/),
              createIDsValidatorEstate('PIN', this.getTestators(), this.testators)
            ]
          );
        }

        if (testator.detailsDone == true) {
          this.validationService.addOrRemoveValidator(true, form.get('IDNoImage')!);
          this.validationService.addOrRemoveValidator(true, form.get('KraPinImage')!);
        }
      }
      // console.log('Current record verified: ', this.currentRecordVerified, '\n', testator);
    } else {
      if (
        this.testators && this.testators.length > 0 && this.testators[0].verified == false
      ) {

          this.estateControlService.refreshRecordWill(1);
      }

      let currentTestators = this.testators;
      let currentRecord: any = {verified: false, detailsDone: false, done: false};

      form = this._formBuilder.group({
        Title: [''],
        FirstName: ['', Validators.required],
        MiddleName: [''],
        LastName: ['', Validators.required],
        Phone: ['', Validators.required],
        SecondaryPhone: [''],
        Email: ['', [Validators.required, Validators.email]],
        IDNo: ['', [Validators.required, Validators.min(4)]],

        KraPin: [''],
        Address: [''],
        PostalAddress: [''],

        IDNoImage: [''],
        KraPinImage: [''],
        Photo: ['']
      });

      if (this.testatorForm && this.getTestators().length > 0) {
        this.validationService.addOrRemove3Validators(
          true,
          form.get('Email')!,
          [Validators.required,
            Validators.email,
            createIDsValidatorEstate('EMAIL', this.getTestators(), this.testators)
          ]
        );
        this.validationService.addOrRemoveSpecificValidators(
          true,
          form.get('Phone')!,
          [Validators.required,
            createIDsValidatorEstate('TEL', this.getTestators(), this.testators)
          ]
        );
        this.validationService.addOrRemoveOneValidator(
          true,
          form.get('SecondaryPhone')!,
          [createIDsValidatorEstate('TEL', this.getTestators(), this.testators)]
        );
        this.validationService.addOrRemove3Validators(
          true,
          form.get('IDNo')!,
          [Validators.required,
            Validators.min(4),
            createIDsValidatorEstate('ID', this.getTestators(), this.testators)
          ]
        );
      }

      if (
        this.testators.length == 0 ||
        this.testators.length > 0 && this.testators[this.testators.length-1].done == true
      ) {
        currentTestators.push(currentRecord);
        this.estateControlService.updateRecordWill(1, currentTestators);
      }
      
    }

    form.updateValueAndValidity();

    return form;
  };

  async addNewTestator() {
    const fields = this.testatorForm.get('testators') as FormArray;
    const newFormGroup = this.createTestatorsFormGroup();
    fields.push(newFormGroup);
    this.testatorForm.setControl('testators', fields);

    // Wait for view to update
    await new Promise(resolve => setTimeout(resolve));
    const newIndex = fields.length - 1;
    this.testatorPanels[newIndex] = this.generatePanelsForTestator(newIndex);

    // Set up listeners after panels are generated
    this.setupFormChangeListenersForIndex(newIndex);
    this.cdr.detectChanges();
  }

  async removeTestator(i:number) {
    this.currentIndex = i;
    const fields = this.testatorForm.get('testators') as FormArray;
    let currentTestators = this.testators;
    
    if (currentTestators[i] && currentTestators[i].TestatorID) {
      this.removeButtonText = 'Removing Testator';
      this.loadingRemove = true;
      
      try {
        if (this.estateControlService.TrustID !== null) {
          const result = await this.estateControlService.removeRecord(
            'testator',
            currentTestators[i].TestatorID,
            parseInt(this.estateControlService.TrustID),
            environment.baseUrl + Constants.willTestatorURL
          );

          if (result === 1) {
            this.notificationService.viewToast('success', 'Testator removed successfully');
            fields.removeAt(i);
            // Remove testator at index
            currentTestators.splice(i, 1);;
            await this.estateControlService.updateRecordWill(1, currentTestators);
          } else {
            this.notificationService.viewToast('error', 'Error removing record');
          }
        } else {
          console.log('Relevant IDs not found');
        }
      } catch (error) {
        console.log(':: Error !! ', error);
      }
      this.removeButtonText = 'Remove Testator';
      this.loadingRemove = false;
    } else {
      if (currentTestators[i] && currentTestators[i].done === false) {
        fields.removeAt(i);
        // Remove testator at index
        currentTestators.splice(i, 1);;
        await this.estateControlService.updateRecordWill(1, currentTestators);
      } else {
        fields.removeAt(i);
      }
    }
    if (this.getTestators().length < 1) this.addNewTestator();
    setTimeout(()=> {
      this.generatePanelsForTestator(i);
      this.testators.forEach((testator: any, index: number) => {
        this.updateContactInfoDoneStatus(index, testator);
      });
    })
  }
  getTestators() : FormArray {  
    return this.testatorForm.get("testators") as FormArray  
  }
  getTestatorFormGroup(index: number): FormGroup {
    const testators = this.testatorForm.get('testators') as FormArray;
    return testators.at(index) as FormGroup;
  }

  async openOtpModal(index?: number) {
    this.loadingText = 'Requesting OTP';
    this.notificationService.isLoading(true);

    try {
      const records = this.testatorForm.controls['testators'].value;
      const currentIndex = index ?? records.length-1;

      let data = {
        Region: this.region,
        FirstName: records[currentIndex].FirstName,
        LastName: records[currentIndex].LastName,
        Phone: records[currentIndex].Phone,
        Email: records[currentIndex].Email,
        MileleType: 'estate'
      };

      this.estateControlService.OTPMessage = `In order to proceed, please enter the One Time Password (OTP) sent to the Testator\'s email and phone`;
      // console.log('Dat ', data);

      let savedTime = this.estateControlService.OTPRequestStats;
      let response = {Status: 0, Message: 'Initialized'};

      this.estateControlService.OTPValid = checkTime(savedTime.time);

      if (this.estateControlService.OTPValid && savedTime.phone === data.Phone) {
        response.Status = 1;
        response.Message = 'Current OTP is still Valid';

      } else {
        response = await this.apiService.postRequest(
          environment.baseUrl + Constants.otpRequestURL, data);
      }

      if (response.Status === 1) {
        let currentTestators = this.testators;
        let currentRecord = currentTestators[currentIndex];
        let otpVerified = false;

        currentRecord = {...currentRecord, ...records[currentIndex]};
        
        Object.assign(currentTestators[currentIndex], currentRecord);
        await this.estateControlService.updateRecordWill(1, currentTestators);
        
        if (!this.estateControlService.OTPValid) {
          const timeStats = {time: new Date().getTime() / 1000, phone: data.Phone};
          this.estateControlService.OTPRequestStats = timeStats;
          this.estateControlService.OTPValid = true;

          if (this.region == 1) { // Diaspora
            this.notificationService.viewToast(
              'success',
              `OTP sent to ${data.Email}.`);
          } else {
            this.notificationService.viewToast(
              'success',
              `OTP sent to ${data.Phone}.`,
              'We have also sent it to the provided Email');
          }

        } else {
          this.notificationService.viewToast(
            'info',
            `Please enter the OTP that was sent to your ${this.region === 1 ? 'Email' : 'Phone / Email'}` );
        }

        this.estateControlService.OTPRequestPage = 'Testator';
        this.estateControlService.OTPIndex = currentIndex;
        
        this.loadingText = 'Verify Details';

        const dialogRef = this.dialog.open(OtpPopupComponent, {
          disableClose: true,
        });
    
        dialogRef.componentInstance.otpVerified.subscribe((value: boolean) => {
          otpVerified = value;
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (otpVerified == true) {
            let currentTestators = this.testators;
            let currentRecord = currentTestators[currentIndex];
            currentRecord.verified = true;

            Object.assign(currentTestators[currentIndex], currentRecord);
            this.estateControlService.updateRecordWill(1, currentTestators);

            if (this.testators.length <= 1) this.submitForm();
            else {
              this.validationService.addOrRemoveValidator(true, this.getTestatorFormGroup(currentIndex).get('Address')!);
              this.validationService.addOrRemoveValidator(true, this.getTestatorFormGroup(currentIndex).get('PostalAddress')!);

              if (currentIndex > 0) {
                this.validationService.addOrRemove3Validators(
                  true,
                  this.getTestatorFormGroup(currentIndex).get('KraPin')!,
                  [Validators.required,
                    Validators.pattern(/^[AP]\d{9}[A-Z]$/),
                    createIDsValidatorEstate('PIN', this.getTestators(), this.testators)
                  ]
                );
              } else {
                this.validationService.addOrRemoveSpecificValidators(
                  true,
                  this.getTestatorFormGroup(currentIndex).get('KraPin')!,
                  [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]
                );
              }

              this.updateContactInfoDoneStatus(currentIndex, currentRecord);
              this.getTestatorFormGroup(currentIndex).get('Address')?.updateValueAndValidity();
              this.getTestatorFormGroup(currentIndex).get('PostalAddress')?.updateValueAndValidity();
              this.getTestatorFormGroup(currentIndex).get('KraPin')?.updateValueAndValidity();

              setTimeout(()=> {  
                this.cdr.detectChanges();
              })
            }

          } else {
            this.notificationService.viewToast('info', 'Please verify your details to proceed');
          }
        });
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.log(':: Error !! ', error);
      this.notificationService.viewToast('error', 'OTP request failed');

    }
    this.notificationService.isLoading(false);
  }

  async saveTestator(index?: any): Promise<void> {
    if (index || this.testators[this.testators.length-1].verified == true) this.loadingText = 'Updating Testator';
    else this.loadingText = 'Saving Testator';

    let tsMessage = 'Testator details saved';

    this.notificationService.isLoading(true);

    try {
      const testators = this.testatorForm.get('testators') as FormArray;
      const currentIndex = index ?? testators.length - 1;
      const record: FormGroup = this.getTestatorFormGroup(currentIndex) as FormGroup;

      let category;
      if (this.estateControlService.TrustID === null || currentIndex === 0) {
        category = 'Primary Testator';
      } else {
        category = 'Secondary Testator';
      }
      
      let data = {
        ...record.getRawValue(),
        ...{
          TrustID: this.estateControlService.TrustID,
          Category: category
        }
      };

      let currentTestators = this.testators;
      
      if (currentTestators[currentIndex].detailsDone == true) {
        data.IDNoImage = this.testators[currentIndex].IDNoImage;
        data.KraPinImage = this.testators[currentIndex].KraPinImage;
      } else {
        data.IDNoImage = {name: '', stringValue: ''};
        data.KraPinImage = {name: '', stringValue: ''};
      }

      if (currentTestators[currentIndex].TestatorID) {
        data = {...data, ...{TestatorID: currentTestators[currentIndex].TestatorID}};
      }
      
      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.willTestatorURL, data, false);
      
      // console.log('::::: RESPONSE ::::::\n', response);
      if (response.Status === 1) {
        if (this.estateControlService.TrustID === null) {
          this.estateControlService.TrustID = response.TrustID;
          this.estateControlService.updateWillProgress('Testators');
        }

        currentTestators = this.testators;
        const latestRecord = currentTestators[currentIndex];
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(record.getRawValue()).filter(([key]) => !key.includes('Image'))
        );
        let updatedRecord = {
          ...latestRecord,
          ...recordValueWithoutImages,
          ...{TestatorID: response.TestatorID, Category: category}};

        Object.assign(currentTestators[currentIndex], updatedRecord);

        await this.estateControlService.updateRecordWill(1, currentTestators);

        currentTestators = this.testators;
        let currentRecord = currentTestators[currentIndex];
        
        if (currentRecord.detailsDone) { // uploaded docs
          tsMessage = 'Testator details updated';

          if (data.IDNoImage && data.IDNoImage.stringValue.length > 5 && response.IdURL) {
            currentRecord = {...currentRecord, ...{IDURL: response.IdURL, SavedID: currentRecord.IDNoImage}};
            this.estateControlService.removeFromDocSummary('ID', 'Testator', currentRecord.TestatorID);
            this.estateControlService.updateDocSummary(response.IdURL);
          }
          if (data.KraPinImage && data.KraPinImage.stringValue.length > 5 && response.KraURL) {
            currentRecord = {...currentRecord, ...{KraURL: response.KraURL, SavedPIN: currentRecord.KraPinImage}};
            this.estateControlService.removeFromDocSummary('PIN', 'Testator', currentRecord.TestatorID);
            this.estateControlService.updateDocSummary(response.KraURL);
          }
          
          currentRecord.done = true;

        } else {
          currentRecord.detailsDone = true;
          this.validationService.addOrRemoveValidator(true, this.getTestatorFormGroup(currentIndex).get('IDNoImage')!);
          this.validationService.addOrRemoveValidator(true, this.getTestatorFormGroup(currentIndex).get('KraPinImage')!);
          this.testatorForm.updateValueAndValidity();
          
        }
        setTimeout(() => {
          this.cdr.detectChanges();
        });
        
        Object.assign(currentTestators[currentIndex], currentRecord);
        await this.estateControlService.updateRecordWill(1, currentTestators);
        this.notificationService.viewToast('success', tsMessage);
        this.updateContactInfoDoneStatus(currentIndex, currentRecord);
        
        if (!environment.production) console.log('>> New Testators !! \n', this.estateControlService.testators);
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: saveTestator : ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
  }

  async submitForm(): Promise<void> {
    if (this.testators[this.testators.length-1].done) {
      this.navigateFunction();
    } else {
      if (this.testators[this.testators.length-1].verified) {
        if (this.testators.length <= 1 && !this.consentProvided) this.openConsentForm();
        else  this.saveTestator();
      } else {
        this.openOtpModal();
      }
    }
  }
  async navigateFunction(): Promise<void> {
    await this.estateControlService.changeTabWill(2);
    this.estateControlService.page1Done = true;
  }

  async updateRecord(index: number) {
    await this.saveTestator(index);
  }


  // ==============  CONSENT LOGIC   =================
  openConsentForm = () => {
    const user: ConsentClient = {
      FirstName: this.testators[0]?.FirstName || '',
      LastName: this.testators[0]?.LastName || '',
      Phone: this.testators[0]?.Phone || '',
      IDNo: this.testators[0]?.IDNo || ''
    };

    const consentData = {
      channelId: environment.channelID,
      client: user,
      appId: environment.appID,
      appPass: environment.appPass,
      consentSource: 'Milele Trust Microsite',
      company: 'ILTC',
      persist: false,
      onSubmit: (selectedConsents: ConsentItem[], allConsents: ConsentItem[]) => {
        let allAccepted = true;
        let notAccepted: ConsentItem[] = [];

        allConsents.forEach((consent: ConsentItem) => {
          if (!consent.selected && consent.mandatory) {
            allAccepted = false;
            notAccepted.push(consent);
          }
        })

        if (allAccepted) {
          this.notificationService.viewToast('success', 'Thank you');
          this.consentAndNavigate();

        } else {
          let skippedConsents = notAccepted[0].name;
          if (notAccepted.length > 1) {
            notAccepted.forEach((consent: ConsentItem, index: number) => {
              if (index > 0) {
                if (index == notAccepted.length-1) skippedConsents+= ` & ${consent.name}`;
                else skippedConsents+= `, ${consent.name}`;
              }
            })
          }
          
          // Notify user omitted required consent(s)
          this.notificationService.viewToast(
            'error',
            `You need to agree to the below consent ${(notAccepted.length === 1 ? 'item' : 'items')} in order to proceed`,
            skippedConsents,
            true
          );
        }
      },
      onClose: () => {
        // Handle when user closes without submitting
        this.notificationService.viewToast(
          'error',
          'Action Required',
          'Please accept the mandatory terms of service to continue',
          true
        );
      }
    };

    this.consentService.loadConsentForm(consentData);
  }

  consentAndNavigate = async() => {
    this.validationService.addOrRemoveValidator(true, this.getTestatorFormGroup(this.testators.length - 1).get('Address')!);
    this.validationService.addOrRemoveValidator(true, this.getTestatorFormGroup(this.testators.length - 1).get('PostalAddress')!);

    if (this.testatorForm && this.getTestators().length > 0) {
      this.validationService.addOrRemove3Validators(
        true,
        this.getTestatorFormGroup(this.testators.length - 1).get('KraPin')!,
        [Validators.required,
          Validators.pattern(/^[AP]\d{9}[A-Z]$/),
          createIDsValidatorEstate('PIN', this.getTestators(), this.testators)
        ]
      );
    } else {
      this.validationService.addOrRemoveSpecificValidators(
        true,
        this.getTestatorFormGroup(this.testators.length - 1).get('KraPin')!,
        [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]
      );
    }
    this.testatorForm.updateValueAndValidity();
    setTimeout(() => {
      this.cdr.detectChanges();
    });
    this.consentProvided = true;
    this.consentService.closeConsentForm();
    this.updateContactInfoDoneStatus(this.testators.length - 1, this.testators[this.testators.length - 1]);
  }

  // ==============  EXPANSION SECTION   =================
  @ViewChild('contactInfo') contactInfo!: TemplateRef<any>;
  @ViewChild('details') details!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;


  generatePanelsForTestator = (i: number): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.contactInfo || !this.details || !this.uploadDocs || !this.testators[i]) {
      return [];
    }
    return [
      {
        title: 'Contact Information',
        contentTemplate: this.contactInfo,
        context: { index: i },  // Add this line
        expanded: !(this.testators[i].verified),
        done: (this.testators[i].verified)
      },
      {
        title: 'Details',
        contentTemplate: this.details,
        context: { index: i },  // Add this line
        disabled: !(this.testators[i].verified && this.consentProvided),
        expanded: (this.testators[i].verified && this.consentProvided && !this.testators[i].detailsDone),
        done: (this.testators[i].detailsDone)
      },
      {
        title: 'Upload Documents',
        contentTemplate: this.uploadDocs,
        context: { index: i },  // Add this line
        disabled: !(this.testators[i].detailsDone),
        expanded: (this.testators[i].detailsDone && !this.testators[i].done),
        done: (this.testators[i].done)
      }
    ];
  }

  updateContactInfoDoneStatus(i: number, value: any) {
    // Ensure panels array exists
    this.testatorPanels = this.testatorPanels || [];
    
    // Initialize if missing or invalid
    if (!this.testatorPanels[i] || this.testatorPanels[i].length !== 3) {
      this.testatorPanels[i] = this.generatePanelsForTestator(i);
    }

    const panels = this.testatorPanels[i];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = value.verified && this.consentProvided;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: i };
      panels[0].expanded = !value.verified;
    }
    
    if (panels[1]) {
      panels[1].done = value.detailsDone;
      panels[1].context = panels[1].context || { index: i };
      panels[1].disabled = !(value.verified && this.consentProvided);
      panels[1].expanded = !value.detailsDone;
    }
    
    if (panels[2]) {
      panels[2].done = value.done;
      panels[2].context = panels[2].context || { index: i };
      panels[2].disabled = !value.detailsDone;
      panels[2].expanded = !value.done;
    }

    setTimeout(()=> {
      try {
        if (value.TestatorID && !value.done && i == this.testators.length-1) {
          this.notificationService.viewToast(
            'info',
            `Testator ${value.FirstName} ${value.LastName}`,
            `Please continue to ${
              value.detailsDone ? panels[2].title :
              'add your ' +panels[1].title
            }`
          );
        }
        
      } catch (error) {}
      
    })
  }

  private setupFormChangeListeners() {
    // Clean up any existing subscriptions
    this.cleanupFormChangeListeners();
    
    // Set up new listeners for each form group
    this.getTestators().controls.forEach((control, index) => {
      const subscription = (control as FormGroup).valueChanges.subscribe(() => {
        // This will trigger change detection when any form value changes
        this.cdr.detectChanges();
      });
      this.formChangesSubscription.push(subscription);
    });
  }
  private setupFormChangeListenersForIndex(index: number) {
    // Clean up existing subscription if any
    const existingSub = this.formChangesSubscription[index];
    if (existingSub) {
      existingSub.unsubscribe();
    }
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }

  private loggedErrors = new Set<string>();

  confirmFormMatchesRecord(index: number): boolean {
    try {
      const testator = this.testators[index];
      const formGroup = this.getTestatorFormGroup(index);
      
      if (!testator?.done || !formGroup) {
        return true;
      }

      // Fields to compare
      const fieldsToCompare = [
        'Title', 'FirstName', 'MiddleName', 'LastName', 'Phone', 'SecondaryPhone',
        'Email', 'IDNo', 'KraPin', 'Address', 'PostalAddress'
      ];

      // Compare all relevant fields
      const basicFieldsMatch = fieldsToCompare.every(field => {
        const recordValue = testator[field];
        const formValue = formGroup.get(field)?.value;
        const valuesMatch = (formValue || '') === (recordValue || '');
        
        // If either value is empty, consider this field as matching
        return valuesMatch;
      });

      const filesMatch = 
        testator.IDNoImage.name === testator.SavedID.name &&
        testator.KraPinImage.name === testator.SavedPIN.name;

      return basicFieldsMatch && filesMatch;
      
      // Compare file fields if they exist
      
    } catch (error: any) {
      const errorKey = `error-${index}-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }
}
